import { camelCase } from 'lodash';

export class Vehicle {
  id: number = null;
  vehVehicleId: number = null;
  vehRegoNo: string = null;
  vehVehicleSerial: string = null;
  vehDriver: string = null;
  displayText: string = null;
  vehCostCentreId: number = null;
  vehClientReference: string = null;
  vehServiceExpiryDate: string = null;
  vehAnnualFee: number = null;
  newExpiryDate: string = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
